import * as React from 'react';

import { throttle } from '@packages/common';

type EventHandlerMapping = {
  [key in keyof GlobalEventHandlersEventMap]?: () => void;
};

export const useGlobalDOMEvent = (eventMapping: EventHandlerMapping) => {
  React.useEffect(() => {
    for (const [eventName, cb] of Object.entries(eventMapping)) {
      window.addEventListener(eventName, throttle(cb, 200), false);
    }
    return () => {
      for (const [eventName, cb] of Object.entries(eventMapping)) {
        window.removeEventListener(eventName, cb, false);
      }
    };
  }, [eventMapping]);
};
